export const sceneMoire = `
    vec3 sceneMoire(vec2 uv, float time) {
        const float tmax = 10.0;
        float nt = mod(time * 0.1, tmax * 2.0);
        if (nt > tmax) {
          nt = tmax * 2.0 - nt;
        }
        uv.x += nt * 0.05;
        vec2 c1=vec2(sin(nt *.5),cos(nt *.4))*.3; vec2 c2=vec2(sin(nt *.7),cos(nt *.8))*.3;
        float r=sin(length(uv-c1)*200.-nt *4.)+sin(length(uv-c2)*200.+nt *4.);
        return mix(vec3(.1,0.,.3), vec3(0.,1.,.8), smoothstep(.2,.8,abs(r)));
    }
`;
